export default "__VITE_ASSET__DNaeOT69__"